import type { QueryClient, QueryKey } from '@tanstack/vue-query'

// Share REST and socket refreshes within a client. Never abort an existing read;
// a notification arriving during it requires one subsequent read for freshness.
const clients = new WeakMap<QueryClient, Map<string, { timer?: ReturnType<typeof setTimeout>; running: boolean; again: boolean }>>()
export function refreshQueries(client: QueryClient, queryKey: QueryKey) {
  let pending = clients.get(client)
  if (!pending) clients.set(client, pending = new Map())
  const key = JSON.stringify(queryKey)
  let state = pending.get(key)
  if (state?.running) { state.again = true; return }
  if (state?.timer) clearTimeout(state.timer)
  if (!state) { state = { running: false, again: false }; pending.set(key, state) }
  const entry = state
  entry.timer = setTimeout(async () => {
    entry.timer = undefined
    entry.running = true
    const alreadyFetching = client.getQueryCache().findAll({ queryKey }).some(query => query.state.fetchStatus === 'fetching')
    try {
      await client.invalidateQueries({ queryKey }, { cancelRefetch: false })
    } finally {
      entry.running = false
      const repeat = entry.again || alreadyFetching
      pending!.delete(key)
      if (repeat) refreshQueries(client, queryKey)
    }
  }, 150)
}
